import React, { useEffect, useRef, useState } from 'react';
import countryCodes from './countryCodes';

const CountryCodeSelect = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState('');
    const containerRef = useRef(null);

    const selected = countryCodes.find((c) => c.dialCode === value) || countryCodes[0];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
                setQuery('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filteredCountries = countryCodes.filter((c) =>
        `${c.name} ${c.dialCode}`.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelect = (dialCode) => {
        onChange(dialCode);
        setIsOpen(false);
        setQuery('');
    };

    return (
        <div className="relative" ref={containerRef}>
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="flex items-center gap-1 h-full px-2 py-2 bg-white border-2 border-[#BED0C5CC] rounded-l-md focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] sm:text-sm"
            >
                <img src={selected.flagUrl} alt={selected.iso2} className="w-5 h-4 object-cover" />
                <span>{selected.dialCode}</span>
            </button>

            {isOpen && (
                <div className="absolute z-10 mt-1 w-64 max-h-60 overflow-y-auto bg-white border-2 border-[#BED0C5CC] rounded-md shadow-lg">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Search country"
                        className="w-full px-3 py-2 border-b border-[#BED0C5CC] focus:outline-none sm:text-sm"
                        autoFocus
                    />
                    <ul>
                        {filteredCountries.map(({ name, dialCode, iso2, flagUrl }) => (
                            <li key={`${iso2}-${dialCode}`}>
                                <button
                                    type="button"
                                    onClick={() => handleSelect(dialCode)}
                                    className="flex items-center gap-2 w-full text-left px-3 py-2 hover:bg-[#7998EC1A] sm:text-sm"
                                >
                                    <img src={flagUrl} alt={iso2} className="w-5 h-4 object-cover shrink-0" />
                                    <span className="flex-1">{name}</span>
                                    <span className="text-gray-500">{dialCode}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CountryCodeSelect;
